import useUrlState from '@ahooksjs/use-url-state';
import { Card } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { BookingList } from '@/components/booking';
import { CalendarHeader } from '@/components/calendar';
import { BookingStatus, BookingType } from '@/models';
import { useBookings } from '@/web-api/bookings';

export const BookingsPage = () => {
  const [urlState, setUrlState] = useUrlState({
    selectedDate: dayjs().toISOString(),
    selectedTypes: [],
    selectedCustomers: [],
    selectedLanguages: [],
    selectedResources: [],
    selectedStatus: [],
    selectedLocations: [],
  });

  const { t } = useTranslation();

  const { data: bookings, isFetching } = useBookings({
    types: urlState.selectedTypes,
    customers: urlState.selectedCustomers,
    languages: urlState.selectedLanguages,
    resources: urlState.selectedResources,
    locations: urlState.selectedLocations,
    status: urlState.selectedStatus,
    month: dayjs(urlState.selectedDate).month(),
    year: dayjs(urlState.selectedDate).year(),
  });

  const onFilterChange = (
    date: Dayjs,
    types: BookingType[],
    customerIds: string[],
    serviceIds: string[],
    resourceIds: string[],
    status: BookingStatus[],
    locations: string[]
  ) => {
    setUrlState({
      selectedDate: date.toISOString(),
      selectedTypes: types,
      selectedCustomers: customerIds,
      selectedLanguages: serviceIds,
      selectedResources: resourceIds,
      selectedStatus: status,
      selectedLocations: locations,
    });
  };

  return (
    <Card
      title={t('common:bookings')}
      styles={{
        header: {
          position: 'sticky',
          top: -16,
          zIndex: 1000,
          backgroundColor: 'white',
        },
      }}
      extra={
        <CalendarHeader
          onChange={onFilterChange}
          selectedDate={dayjs(urlState.selectedDate)}
          selectedTypes={urlState.selectedTypes}
          selectedCustomers={urlState.selectedCustomers}
          selectedResources={urlState.selectedResources}
          selectedLanguages={urlState.selectedLanguages}
          selectedStatus={urlState.selectedStatus}
          selectedLocations={urlState.selectedLocations}
        />
      }
    >
      <BookingList bookingData={bookings} isLoading={isFetching} />
    </Card>
  );
};
